/**
 * The size of the history panel. Equals the size of the chat.
 */
export const HISTORY_PANEL_SIZE = 315;
